import React from 'react';
import { SidebarInset } from './ui/sidebar';
import { DocumentLoadingScreen } from './DocumentLoadingScreen';
import { APP_VIEWPORT_HEIGHT } from '../constants/layout';

export const DocumentLoadingPanel: React.FC = () => {
  return (
    <SidebarInset className="editor-main-inset" style={{ overflow: 'hidden', height: APP_VIEWPORT_HEIGHT }}>
      <DocumentLoadingScreen variant="panel" />
    </SidebarInset>
  );
};
